export const FETCH_BOOKIES = 'FETCH_BOOKIES';
export const ADD_BOOKIES = 'ADD_BOOKIES';
export const DELETE_BOOKIES ='DELETE_BOOKIES';
export const UPDATE_BOOKIES ='UPDATE_BOOKIES';